// Adddress common fields
const email =
  '<a href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#111;&#102;&#102;&#105;&#99;&#101;&#64;&#104;&#101;&#121;&#103;&#117;&#121;&#115;&#46;&#105;&#111;">&#111;&#102;&#102;&#105;&#99;&#101;&#64;&#104;&#101;&#121;&#103;&#117;&#121;&#115;&#46;&#105;&#111;</a>'
const street = 'Kosynierów 44'
const city = '41-219 Sosnowiec'
const address = `${street}\n${city}`
const NIP = 'NIP: 6443529837'
const REGON = 'REGON: 368029292'
const KRS = 'KRS: 0000696545'
const phone = '+48 721 680 759'

const enContent = {
  common: { backToTop: 'go to the top' },
  navigation: {
    about: 'About us',
    projects: 'Projects',
    career: 'Career',
    contact: 'Contact us',
  },
  footer: {
    email,
    companyInfo: {
      street,
      city,
      NIP,
      REGON,
      KRS,
    },
    privacyLink: {
      label: 'Privacy policy',
      to: '/privacy-policy/',
    },
  },
  pages: {
    home: {
      sections: {
        header: {
          headline: 'Digital marketing \nand web development\nthat',
          headlineEnd: 'makes you smile',
          image: require('../images/home/headerImage.webp'),
          imageMobile: require('../images/home/headerImageMobile.webp'),
          imageAlt: 'Company employers smiling',
          button01: {
            label: 'Join us!',
            to: '/career/',
          },
          button02: {
            label: 'Get in touch',
            to: '/contact/',
          },
        },
        circles: {
          headline: 'Build your digital brand with a smile!',
          text: 'Web development makes you unhappy?',
          circle01: {
            text: 'Websites that your\ncustomers will love',
          },
          circle02: {
            text: 'Digital marketing campaigns\n to gain new clients',
          },
          circle03: {
            text: 'Animations that make\n your brand shine',
          },
        },
        cases: {
          headline: 'We created a smile a thousand times:',

          button: {
            label: 'check our portfolio',
            to: '/projects',
          },
          case01: require('../images/home/case01.webp'),
          alt01: 'Our project - David und Martin',
          case02: require('../images/home/case02.webp'),
          alt02: 'Our project - Franz Eberhofer',
          case03: require('../images/home/case03.webp'),
          alt03: 'Our project - ipox',
          case04: require('../images/home/case04.webp'),
          alt04: 'Our project - Franz Eberhofer',
          case05: require('../images/home/case05.webp'),
          alt05: 'Our project - Fournell',
          case06: require('../images/home/case06.webp'),
          alt06: 'Our project - Digital Design',
        },
        cards: {
          card01: {
            headline: 'Code based on latest technology',
            text: 'We love getting better. And if there are new ways to code our projects we happily try them out. Better results this way? Ok, lets keep it. Didn’t really work out? It was at least worth a try.',
          },
          card02: {
            headline: 'Web design for cool and professional websites',
            text: 'We believe that really good websites can just be created if you do it as one team. Because of this UX-, UI- and Motion-Design and Development in our company aren’t different departments.',
          },
          card03: {
            headline: 'Display campaigns combining brand and performance',
            text: 'We are specialised in display campaigns that sell products AND look great. By this approach we combine performance and branding to 100 % brandformance. We decide when you can have both?',
          },
        },
        team: {
          headline: 'Meet our team',
          text: 'HeyGuys is more than just a company, it’s a team of people who share their experience and put passion into the projects. Work is not only the daily challenges and motivations, it’s above all a great fun and inspiration. We create friendly atmosphere where we feel good.',
          button: {
            label: 'about us!',
            to: '/about',
          },
          image01: require('../images/home/team01.webp'),
          alt01: 'team',
          image02: require('../images/home/team02.webp'),
          alt02: 'team selfie',
        },
        jobs: {
          headline: 'Join us!',
          text: 'Currently we are looking for:',
          jobButton01: {
            label: 'Junior Frontend Developer',
            to: '/career/junior-frontend-developer/',
          },
          jobButton02: {
            label: 'Student - banners development support',
            to: '/career/student-banner-development-support/',
          },
          smallButton: { label: 'see more', to: '/career/' },
        },
      },
    },

    about: {
      sections: {
        subheader: {
          headline:
            'A remarkable place is&nbsp;created&nbsp;by<br>unique people',
          smile: true,
        },
        teamGallery: {
          lastItem: {
            label: 'Maybe you?',
            to: '/career/',
            button: 'career',
          },
          imageAlt: 'one of heyguys team',
          galleryData: [
            {
              image: require('../images/about/team01.webp'),
              name: 'Agnieszka Irzykowska',
              role: 'Frontend Developer',
            },
            {
              image: require('../images/about/team02.webp'),
              name: 'Robert Gontarczyk',
              role: 'Head of office',
            },
            {
              image: require('../images/about/lukasz.jpg'),
              name: 'Łukasz Pawela',
              role: 'Frontend Developer',
            },
            {
              image: require('../images/about/natalia-g.jpg'),
              name: 'Natalia Grzesik',
              role: 'Digital Designer',
            },
            {
              image: require('../images/about/team05.webp'),
              name: 'Marek Służałek',
              role: 'Senior Frontend Developer',
            },
            {
              image: require('../images/about/team09.webp'),
              name: 'Joanna Gontarczyk',
              role: 'Office Manager',
            },
            {
              image: require('../images/about/team10.webp'),
              name: 'Uli Hattenberger & Dr David Hanisch',
              role: 'Management',
            },
            {
              image: require('../images/about/kasia.jpg'),
              name: 'Katarzyna Breczko',
              role: 'Creative Director',
            },
            {
              image: require('../images/about/team15.webp'),
              name: 'Barbara Knopek',
              role: 'Digital Designer',
            },
            {
              image: require('../images/about/team13.webp'),
              name: 'Szymon Piątkowski',
              role: 'Frontend Developer',
            }, 
            {
              image: require('../images/about/basia.jpg'),
              name: 'Barbara Koźbiał',
              role: 'Motion Designer',
            },
            {
              image: require('../images/about/mg-p4.jpg'),
              name: 'Mateusz Grek',
              role: 'Frontend Developer',
            },
                
            
          ],
        },
        events: {
          text: 'events',
          image01: require('../images/about/image06.webp'),
          alt01: 'five-year anniversary - team photo ',
          image02: require('../images/about/image07.webp'),
          alt02: 'team in tent at Oktoberfest',
          image03: require('../images/about/image08.webp'),
          alt03: 'five-year anniversary - party',
          image04: require('../images/about/image09.webp'),
          alt04: 'team in center of Munich',
          image05: require('../images/about/image10.webp'),
          alt05: 'team event in Karpacz',
        },
        teamGalleryAfterWork: {
          text: 'after work',
          image01: require('../images/about/image01.webp'),
          alt01: 'team having a barbecue',
          image02: require('../images/about/image02.webp'),
          alt02: 'team having fun in city centre',
          image03: require('../images/about/image03.webp'),
          alt03: 'team having fun after work in Katowice',
          image04: require('../images/about/image04.webp'),
          alt04: 'tteam having fun after work in Dąbrowa Górnicza',
          image05: require('../images/about/image05.webp'),
          alt05: 'team sitting and smiling',
        },
      },
    },
    projects: {
      sections: {
        subheader: {
          headline: 'Our realisations',
          smile: true,
        },
        projects: {
          text: 'portfolio',
          addnotation:
            'Project done in collaboration with our partner agency <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger GmbH</a>',
          projectsData: [
            {
              headline: 'Website for advertising agency David+Martin',
              text: 'Video is king on this website for advertising agency David+Martin. Their impressive creative work for clients from different branches comes to life on this website using special front end components for quick speed and flawless playback.',
              button: {
                label: 'see more',
                href: 'https://davidundmartin.com/en/',
              },
              image01: require('../images/projects/dum.webp'),
              image02: require('../images/projects/dum_2.webp'),
              alt01: 'David+Martin Website Overview',
              alt02: 'David+Martin Website Landing Page',
            },
            {
              headline: 'Website for consulting firm T60',
              text: 'T60 stands for professionalism. Experience and expertise. The website reflects the company culture and their approach to getting things done. Straightforward and on point to help their clients from different fields achieve their goals.',
              button: {
                label: 'see for yourself',
                href: 'https://t60.com/',
              },
              image01: require('../images/projects/t60.webp'),
              image02: require('../images/projects/t60_2.webp'),
              alt01: 'T60 Website Overview',
              alt02: 'T60 Website Landing Page',
            },
            {
              headline: 'Website for Schmitts Katze',
              text: 'A website that puts banners in the center and celebrates display design possibilities: from badges to animation. The result is an absolutely individual and strongly design-driven online presence that shows what is possible with display campaigns.',
              button: {
                label: 'see for yourself',
                href: 'https://schmitts-katze.de/',
              },
              image01: require('../images/projects/image05.webp'),
              image02: require('../images/projects/image06.webp'),
              alt01: 'Schmitts Katze Landing Page',
              alt02: 'Schmitts Katze Stickers and Badges',
            },
            {
              headline: 'Website/e-magazine Citro\u00EBnist',
              text: 'The joy of driving becomes tangible online with the “The Citro\u00EBnist” e-magazine. Transforming the content to the digital world this website offers a fun way for fans of the great French car brand to engage with models, mobility and special offers.',
              button: {
                label: 'see more',
                href: 'https://citroenist-mag.ch/de/',
              },
              image01: require('../images/projects/citroenist.webp'),
              image02: require('../images/projects/citroenist_2.webp'),
              alt01: 'e-magazine Citro\u00EBnist Website Overview',
              alt02: 'e-magazine Citro\u00EBnist Website Landing Page',
            },
            {
              headline: 'Website for real estate company Triebwerk M\u00FCnchen',
              text: 'Set in a former workshop for rail repairs, Triebwerk M\u00FCnchen offers unique rentals in Munich. The rich history of the site and the “one of a kind” properties come to life on the website, combining tradition and modern living in the heart of Munich.',
              button: {
                label: 'see for yourself',
                href: 'https://triebwerk-munchen.de/',
              },
              image01: require('../images/projects/triebwerk.webp'),
              image02: require('../images/projects/triebwerk_2.webp'),
              alt01: 'Triebwerk M\u00FCnchen Landing Page',
              alt02: 'Triebwerk M\u00FCnchen Website Overview',
            },
            {
              headline: 'Website for wood manufacturer Holzhaus Fabrik',
              text: 'Wood is a sustainable resource that works ideally for creating high quality houses. At Holzhaus Fabrik wood is used to create buildings for the future. The website showcases the different types of products and the story behind the company in an elegant and functional way.',
              button: {
                label: 'see more',
                href: 'https://holzhausfabrik.com/',
              },
              image01: require('../images/projects/fhe.webp'),
              image02: require('../images/projects/fhe_2.webp'),
              alt01: 'Holzhaus Fabrik Website Overview',
              alt02: 'Holzhaus Fabrik Website Landing Page',
            },
            {
              headline: 'Website for consulting firm FTI Andersch',
              text: 'Challenges that turn into chances are the main theme on this website for consulting firm FTI Andersch. From the start people can see the power of transformation in action with special animations that create a dynamic user experience.',
              button: {
                label: 'have a look',
                href: 'https://www.fti-andersch.com/',
              },
              image01: require('../images/projects/fti.webp'),
              image02: require('../images/projects/fti_2.webp'),
              alt01: 'FTI Andersch Landing Page',
              alt02: 'FTI Andersch Website Overview',
            },
            {
              headline: 'Website relaunch for Fournell',
              text: 'A website that starts with and is connected through a spark. Quite a challenge to realize with modules which can be dragged and dropped freely wherever the client wants them to be. But the result was definetely worth it!',
              button: {
                label: 'see for yourself',
                href: 'https://fournell.de/',
              },
              image01: require('../images/projects/image07.webp'),
              image02: require('../images/projects/image08.webp'),
              alt01: 'Fournell Landing Page',
              alt02: 'Fournell Website',
            },
            {
              headline: 'Fanpage for Franz Eberhofer',
              text: 'A digital home for the fans of the bavarian cult figure Franz Eberhofer which doesn’t just sell movies and books but really brings his world to life: starting from his favorite pub up till his grandmothers kitchen.',
              button: {
                label: 'get to know him',
                href: 'https://franz-eberhofer.de/',
              },
              image01: require('../images/projects/image03.webp'),
              image02: require('../images/projects/image04.webp'),
              alt01: 'Franz Eberhofer Website Overview',
              alt02: 'Franz Eberhofer and his dog',
            }
          ],
        },
        joinUs: {
          text: 'join us!',
          headline: 'Let’s do something great together!',
          button: {
            label: 'go to career',
            to: '/career/',
          },
        },
      },
    },
    career: {
      sections: {
        subheader: {
          headline: 'We will welcome you with a smile',
          button: {
            label: 'join us',
            to: '#mail-teaser',
          },
          lineWithCircle: true,
          smile: true,
        },
        cards: {
          text: 'our values',
          cardsData: [
            {
              headline: 'Modernity',
              text: 'We take on new challenges and learn all the time. We’re open to new technologies.',
            },
            {
              headline: 'Development',
              text: 'We do not “stand still”, everything is changing very dynamically in our company. We will support you in your development',
            },
            {
              headline: 'Teamwork',
              text: 'We support each other in working on everyday challenges. We can always count on each other. Every employee is treated equally.',
            },
            {
              headline: 'Homeliness',
              text: 'Coffee, music, warm tea and slippers are provided!',
            },
            {
              headline: 'Openness',
              text: 'Every opinion counts, we are open to new ideas! We communicate directly and honestly.',
            },
            {
              headline: 'Smile',
              text: 'A positive attitude guides us every day!',
            },
          ],
        },
        jobList: {
          headline: 'Currently we are looking for:',
          jobs: [
            'Junior Frontend Developer',
            'Student - banners development support',
          ],
        },
        officeGallery: {
          text: 'teamwork',
          image01: require('../images/career/image01.webp'),
          alt01: 'team games',
          image02: require('../images/career/image02.webp'),
          alt02: 'team games - 2',
          image03: require('../images/career/image03.webp'),
          alt03: 'integration at the office',
          image04: require('../images/career/image04.webp'),
          alt04: 'team photo',
          image05: require('../images/career/image05.webp'),
          alt05: 'drone photo of the team',
        },
        form: {
          headline:
            'There’s no offer for you?\nContact us anyway! We’re\nalways open for new people',
          fields: [
            {
              id: 1,
              name: 'name',
              placeholder: 'Your name',
              type: 'text',
              required: true,
            },
            {
              id: 2,
              name: 'email',
              placeholder: 'Your email',
              type: 'email',
              required: true,
            },
            {
              id: 3,
              name: 'message',
              placeholder: 'Your message',
              type: 'textarea',
              required: true,
            },
          ],
          button: 'Send message',
        },
      },
      subpages: {
        juniorFrontendDeveloper: {
          sections: {
            subheader: {
              headline: 'Junior Frontend Developer',
              description: {
                column01:
                  'We are currently looking for junior frontend developers who are passionate about creating frontends for static and wordpress websites that really make our customers smile. ',
                column02:
                  'You always happy to learn new stuff, enjoy working closely with other developers and designers and don’t rest until all the little details of a webpage just look and feel right? Than we are just the team for you.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'What we offer',
                list: [
                  'A good working athmosphere in a team where people really care about each other and will gladly help you dealing with new challenges',
                  'A bride range of projects from small display campaigns up to big website projects which give you the possibility to have own projects from day 1 on',
                  'A “let’s try it out” athmosphere where good ideas are always welcome',
                  'A permanent employment contract and a good salary',
                  'Trainings during your working hours in fields which are new to you',
                  'Regular team lunches and annual team events',
                ],
              },
              requirements: {
                headline: 'What we are looking for',
                list: [
                  'Team players you just love coding and have some background in that field. Employment based or self teached - passion is worth more to us than a degree.',
                  'We are working closely together with <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> and <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. So communicating in English shouldn’t be a problem for you. If your English isn’t yet as good as you would like it to be: No problem we can support you with courses to get better here.',
                ],
              },
            },
          },
        },
        frontendDeveloper: {
          sections: {
            subheader: {
              headline: 'Frontend Developer',
              description: {
                column01:
                  'We are currently looking for Frontend developers who are passionate about creating frontends for static and wordpress websites that really make our customers smile. ',
                column02:
                  'You always happy to learn new stuff, enjoy working closely with other developers and designers and don’t rest until all the little details of a webpage just look and feel right? Than we are just the team for you.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'What we offer',
                list: [
                  'A good working athmosphere in a team where people really care about each other and will gladly help you dealing with new challenges',
                  'A bride range of projects from small display campaigns up to big website projects which give you the possibility to have own projects from day 1 on',
                  'A “let’s try it out” athmosphere where good ideas are always welcome',
                  'A permanent employment contract and a good salary',
                  'Trainings during your working hours in fields which are new to you',
                  'Regular team lunches and annual team events',
                ],
              },
              requirements: {
                headline: 'What we are looking for',
                list: [
                  'Team players you just love coding and have some background in that field. Employment based or self teached - passion is worth more to us than a degree.',
                  'We are working closely together with <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> and <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. So communicating in English shouldn’t be a problem for you. If your English isn’t yet as good as you would like it to be: No problem we can support you with courses to get better here.',
                ],
              },
            },
          },
        },
        motionDesigner: {
          sections: {
            subheader: {
              headline: 'Motion Designer',
              description: {
                column01:
                  'We are currently looking for motion designers who are specialised in animations for social media, digital campaigns and websites.',
                column02:
                  'You enjoy working closely with graphic designers and developers and don’t rest until all the little details just look and feel right? Than we are just the team for you.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'What we offer',
                list: [
                  'Different models of cooperation - B2B, employment contract or mandate contract',
                  'Flexible working hours + remote work possible',
                  'Fulltime employment',
                  'No business trips needed',
                  'Training budget for all employees',
                  'Small team with international projects',
                  'Enough parking spaces next to the office and one of the biggest fitness clubs in the area next door',
                  'Delicious coffee',
                ],
              },
              requirements: {
                headline: 'What we are looking for',
                list: [
                  'Very good skills in Adobe After Effects and Adobe Photoshop',
                  'Experience in the creation of animations',
                  'Creativity and passion for good design',
                  'Teamspirit',
                  'Nice to have: Experience with Blender or Cinema4D',
                  'We are working closely together with <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> and <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. So communicating in English shouldn’t be a problem for you. If your English isn’t yet as good as you would like it to be: No problem we can support you with courses to get better here.',
                ],
              },
            },
          },
        },
        juniorDigitalDesigner: {
          sections: {
            subheader: {
              headline: 'Junior Digital Designer',
              description: {
                column01:
                  'We are currently looking for junior digital designers. Together we will create animations, videos and banners.',
                column02:
                  'You enjoy working closely with graphic designers and developers and don’t rest until all the little details just look and feel right? Than we are just the team for you.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'What we offer',
                list: [
                  'Different models of cooperation - B2B, employment contract or mandate contract',
                  'Flexible working hours + remote work possible',
                  'Fulltime employment',
                  'No business trips needed',
                  'Training budget for all employees',
                  'Small team with international projects',
                  'Enough parking spaces next to the office and one of the biggest fitness clubs in the area next door',
                  'Delicious coffee',
                ],
              },
              requirements: {
                headline: 'What we are looking for',
                list: [
                  'Knowledge of Adobe Photoshop',
                  'Readiness to learn HTML / CSS',
                  'Creativity and passion for good design',
                  'Teamspirit',
                  'We are working closely together with <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> and <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>. So communicating in English shouldn’t be a problem for you. If your English isn’t yet as good as you would like it to be: No problem we can support you with courses to get better here.',
                ],
              },
            },
          },
        },
        seniorUIDesigner: {
          sections: {
            subheader: {
              headline: 'Senior UI Designer',
              description: {
                column01:
                  'Hello, we are looking for an experienced UI Designer. As our team member you will develop designs that support branding, are fun and evoke emotions.',
                column02:
                  'You will work in a team with developers and motion designers to fully exploit the interactive possibilities of web technologies.',
              },
              arrow: true,
            },
            offerDetails: {
              requirements: {
                headline: 'What we offer',
                list: [
                  'The opportunity to develop and shape a small but growing agency from a creative point of view',
                  'Projects in which you are involved from the first idea to the live launch',
                  'Focus on good creation and our clients, prices and pitches hardly play a role for us',
                  'The processes are well organized and the work plans are reliable',
                  'The chance to closely collaborate with our in-house frontend development team towards a common objective to create awesome and fun-to-use websites',
                  'Open atmosphere with committed and motivated colleagues',
                  'Professional hierarchies without title fights',
                  'Different models of cooperation - B2B, employment contract or mandate contract',
                  'Flexible working hours + remote work possible',
                  'Fulltime employment',
                  'Training budget for all employees',
                  'Delicious coffee in the office',
                  'No business trips needed',
                  'We are working closely together with <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> and <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>',
                ],
              },
              offer: {
                headline: 'What we expect',
                list: [
                  '4+ years experience designing websites in a digital agency or similar environment (portfolio with commercial projects)',
                  'Strong UI skills',
                  'Strong communication and team skills',
                  'Ability to organize your work and involve junior colleagues (multiple projects and priorities)',
                  'Conceptual strength as well as a structured and independent way of working',
                  'Feeling current trends in digital design',
                  'Enthusiasm for branding, communication and digital opportunities',
                  'Very good knowledge of Figma',
                  'Critical thinking',
                  'Human-centered design process',
                  'Attention to details',
                  'Fluent written and spoken English',
                ],
                headline02: 'Nice to have',
                list02: [
                  'Experience in brand design',
                  'Experience in motion design',
                  'Good understanding of UX and the ability to develop intuitive user flows',
                  'Confident handling of text and presentation programs (Word and PowerPoint)',
                ],
              },
            },
          },
        },
        digitalCreativeDirector: {
          sections: {
            subheader: {
              headline: 'Digital Creative Director',
              description: {
                column01:
                  'We are looking for a Creative Director who will oversee the creation of digital brandings and campaigns.',
                column02:
                  'With a team of consultants, developers as well as UI/UX- and motion designers, you will create digital communication with strong branding, emotions and which is fun to consume.',
              },
              arrow: true,
            },
            offerDetails: {
              requirements: {
                headline: 'What we offer',
                list: [
                  'The opportunity to develop and shape a small but growing agency from a creative point of view',
                  'Projects in which you are involved from the first idea to the live launch',
                  'Focus on good creation and our clients, prices and pitches hardly play a role for us',
                  'The processes are well organized and the work plans are reliable',
                  'The chance to closely collaborate with our in-house frontend development team towards a common objective to create awesome and fun-to-use websites',
                  'Open atmosphere with committed and motivated colleagues',
                  'Professional hierarchies without title fights',
                  'Different models of cooperation - B2B, employment contract or mandate contract',
                  'Flexible working hours + remote work possible',
                  'Fulltime employment',
                  'Training budget for all employees',
                  'Delicious coffee in the office',
                  'No business trips needed',
                  'We are working closely together with <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> and <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>',
                ],
              },
              offer: {
                headline: 'What we expect',
                list: [
                  'Enthusiasm for branding, communication, and digital possibilities',
                  'Good knowledge of the mechanics and trends of digital journeys and channels, technical affinity',
                  'At least 5 years of professional creative experience in the field of digital creation and design incl. designing websites, motion design and / or digital campaigns',
                  'Ability to organize your work and involve junior colleagues (multiple projects and priorities)',
                  'Conceptual strength, strong UX/UI skills as well as a structured and independent way of working',
                  'Self-reliance, a quick grasp of concepts, passion for creation and fun working in a team',
                  'Critical thinking, human-centered design process and attention to details',
                  '"Can-do" mentality and solution orientation',
                  'Good knowledge of relevant design tools (e.g. but not mandatory Sketch, XD, Aftereffects, Indesign, Illustrator)',
                  'Confident use of key tools such as Figma and Adobe Cloud Apps',
                  'Fluent written and spoken English',
                ],
                headline02: 'What are your responsibilities',
                list02: [
                  'Develop digital (re-)brandings - from the creative concept to the final',
                  'Develop innovative and high performing digital ad concepts that push the limits of technical and creative possibilities',
                  'Define design principles and create moods, storyboards, layouts, and screen designs for a variety of well-known brands',
                  'Create designs that support branding, are fun to use and trigger emotions',
                  'Work as part of a team with developers and motion designers to fully exploit the interactive possibilities of web technologies to their fullest potential',
                  'Take creative responsibility for working with colleagues from different disciplines such as copywriting, art, motion design, development, strategy, and project management',
                  'Guide your concepts through the coordination and production process.',
                  'Help to understand the expectations and requirements of our customers and translate them into concepts and designs',
                  'You also like to take pen or mouse into your hands to generate ideas or approaches quickly and pragmatically',
                  'You enjoy developing things further. This applies both to our creative style, as well as for our agency products and the way we work together. You contribute ideas, see potential for improvement and address them openly',
                ],
              },
            },
          },
        },
        studentHTML5BannerSpecialist: {
          sections: {
            subheader: {
              headline: 'Student - banners development support',
              description: {
                column01:
                  'We are currently looking for a student to support HTML5 banners development. Together we will create advanced animation in the banners.',
                column02:
                  'You enjoy working closely with graphic designers and developers and don’t rest until all the little details just look and feel right? Than we are just the team for you.',
              },
              arrow: true,
            },
            offerDetails: {
              offer: {
                headline: 'What we offer',
                list: [
                  'Flexible working hours',
                  'Part-time job',
                  'Small team with international projects',
                  'Enough parking spaces next to the office and one of the biggest fitness clubs in the area next door',
                  'Delicious coffee',
                ],
              },
              requirements: {
                headline: 'Nice to have',
                list: [
                  'Basic knowledge of Adobe Photoshop',
                  'Readiness to learn HTML / CSS',
                  'Teamspirit',
                  'We are working closely together with <a href="https://hattenbergerpartner.de/" target="__blank">Hattenberger Partner</a> and <a href="https://schmitts-katze.de/" target="__blank">Schmitts Katze</a>',
                ],
              },
            },
            recruitmentSteps: {
              headline: 'Recruitment steps:',
              circle01: {
                text: '1. Thanks for sending us your CV or LinkedIn profile',
              },
              circle02: {
                text: '2. Call with office manager',
              },
              circle03: {
                text: '3. Interview with team lead',
              },
              circle04: {
                text: '4. Welcome in our team!',
              },
            },
          },
        },
        shared: {
          sections: {
            recruitmentSteps: {
              headline: 'Recruitment steps:',
              circle01: {
                text: '1. Thanks for sending us your CV or LinkedIn profile',
              },
              circle02: {
                text: '2. Nice to get to know you in a phone call',
              },
              circle03: {
                text: "3. Let's check your skills and meet the team",
              },
              circle04: {
                text: '4. Welcome in our team!',
              },
            },
            offerSummary: {
              headline:
                'An option which makes you smile? Then just send us your CV! You have some questions? Just write us or give us a call.',
              email,
              image: require('../images/career/team01.webp'),
              alt: 'Team in Katowice',
            },
          },
        },
      },
    },
    privacy: {
      sections: {
        subheader: {
          headline: 'Privacy Policy',
        },
        content:
          '<div><h2><span>POLITYKA PRYWATNOŚCI I COOKIES</span></h2> </div><div><p>Niniejszy Serwis nie zbiera w sposób automatyczny żadnych informacji, z wyjątkiem informacji zawartych w plikach cookies. Poniższa Polityka plików Cookies (ciasteczek) określa zasady zapisywania i uzyskiwania dostępu do danych na Urządzeniach Użytkowników korzystających z Serwisu do celów świadczenia usług drogą elektroniczną przez Administratora Serwisu.</p></div><div><h2><span>§ 1 DEFINICJE</span></h2><p>1. Serwis&nbsp;- serwis internetowy działający pod adresem&nbsp;www.heyguys.io</p> <br><p>2. Serwis zewnętrzny&nbsp;- serwis internetowe partnerów, usługodawców lub usługobiorców Administratora</p> <br><p>3. Administrator&nbsp;- firma&nbsp;HEYGUYS Sp. z o.o., prowadząca działalność pod adresem:&nbsp;ul. Kosynierów 44, 41-219 Sosnowiec, o nadanym numerze identyfikacji podatkowej (NIP):&nbsp;6443529837,o nadanym numerze REGON:&nbsp;368029292, zarejestrowana w&nbsp;SĄDZIE REJONOWYM KATOWICE WSCHÓD W KATOWICACH, VIII WYDZIAŁ GOSPODARCZY KRAJOWEGO REJESTRU SĄDOWEGO&nbsp;pod numerem KRS:&nbsp;0000696545, świadcząca usługi drogą elektroniczną za pośrednictwem Serwisu oraz przechowująca i uzyskująca dostęp do informacji w urządzeniach Użytkownika</p><br><p>4. Użytkownik&nbsp;- osoba fizyczna, dla której Administrator świadczy usługi drogą elektroniczną za pośrednictwem Serwisu.</p><br><p>5. Urządzenie&nbsp;- elektroniczne urządzenie wraz z oprogramowaniem, za pośrednictwem, którego Użytkownik uzyskuje dostęp do Serwisu</p><br><p>6. Cookies (ciasteczka)&nbsp;- dane tekstowe gromadzone w formie plików zamieszczanych na Urządzeniu Użytkownika</p></div><div><h2><span>§ 2 RODZAJE COOKIES</span></h2><p>1. Cookies wewnętrzne&nbsp;- pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez system teleinformatyczny Serwisu</p><br><p>2. Cookies zewnętrzne&nbsp;- pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez systemy teleinformatyczne Serwisów zewnętrznych</p><br><p>3. Cookies sesyjne&nbsp;- pliki zamieszczane iodczytywane z Urządzenia Użytkownika przez Serwis&nbsp;lub Serwisy zewnętrzne&nbsp;podczas jednej sesji danego Urządzenia. Po zakończeniu sesji pliki są usuwane z Urządzenia Użytkownika.</p> <br><p>4. Cookies trwałe&nbsp;- pliki zamieszczane i odczytywane z Urządzenia Użytkownika przez Serwis&nbsp;lub Serwisy zewnętrzne&nbsp;do momentu ich ręcznego usunięcia. Pliki nie są usuwane automatycznie po zakończeniu sesji Urządzenia chyba że konfiguracja Urządzenia Użytkownika jest ustawiona na tryb usuwanie plików Cookie po zakończeniu sesji Urządzenia.</p></div><div><h2><span>§ 3 BEZPIECZEŃSTWO</span></h2><p>1. Mechanizmy składowania i odczytu&nbsp;- Mechanizmy składowania i odczytu Cookies nie pozwalają na pobierania jakichkolwiek danych osobowych ani żadnych informacji poufnych z Urządzenia Użytkownika.Przeniesienie na Urządzenie Użytkownika wirusów, koni trojańskich oraz innych robaków jest praktycznie niemożliwe</p> <br><p>2. Cookie wewnętrzne&nbsp;- zastosowane przez Administratora Cookie wewnętrzne są bezpieczne dla Urządzeń Użytkowników</p><br><p>3. Cookie zewnętrzne&nbsp;- za bezpieczeństwo plików Cookie pochodzących od partnerów Serwisu Administrator nie ponosi odpowiedzialności. Lista partnerów zamieszczona jest w dalszej części Polityki Cookie.</p></div><div><h2><span>§ 4 CELE DO KTÓRYCH WYKORZYSTYWANE SĄ PLIKI COOKIE</span></h2> <p>1. Usprawnienie i ułatwienie dostępu do Serwisu&nbsp;Administrator może przechowywać w plikach Cookie informacje o preferencjach i ustawieniach użytkownika dotyczących Serwisu aby usprawnić, polepszyć i przyśpieszyć świadczenie usług w ramach Serwisu.</p> <br><p>2. Dane statystyczne&nbsp;- Administrator&nbsp;oraz Serwisy zewnętrzne&nbsp;wykorzystuje pliki Cookie do zbierania i przetwarzania danych statystycznych, takich jak np. statystyki odwiedzin, statystyki Urządzeń Użytkowników czy statystyki zachowań użytkowników. Dane te zbierane są w celu analizy i ulepszania Serwisu.</p> <br><p>3. Serwowanie usług multimedialnych&nbsp;-Administrator&nbsp;oraz Serwisy zewnętrzne&nbsp;wykorzystuje pliki Cookie do serwowania Użytkownikom usług multimedialnych.</p> <br><p>4. Usługi społecznościowe&nbsp;- Administrator&nbsp;oraz Serwisy zewnętrzne&nbsp;wykorzystują pliki Cookie do wsparcia usług społecznościowych.</p></div><div><h2><span>§ 5 SERWISY ZEWNĘTRZNE</span></h2><p>Administrator współpracuje z następującymi serwisami zewnętrznymi, które mogą zamieszczać pliki Cookie na Urządzeniach Użytkownika: Google Analytics, Google+, AddThis, Youtube.</p> </div><div><h2><span>§ 6 MOŻLIWOŚCI OKREŚLANIA WARUNKÓW PRZECHOWYWANIA I UZYSKIWANIA DOSTĘPU NA URZĄDZENIACH UŻYTKOWNIKA PRZEZ SERWIS&nbsp;I SERWISY ZEWNĘTRZNE</span></h2><p>1. Użytkownik może w dowolnym momencie, samodzielnie zmienić ustawienia dotyczące zapisywania, usuwania oraz dostępu do danych zapisanych plików Cookies.</p><br><p>2. Użytkownik może w dowolnym momencie usunąć wszelkie zapisane do tej pory pliki Cookie korzystając z narzędzi Urządzenia Użytkownika, za pośrednictwem którego Użytkownik korzysta z usług Serwisu.</p></div><div><h2><span>§ 7 WYMAGANIA SERWISU</span></h2><p>1. Ograniczenie zapisu i dostępu do plików Cookie na Urządzeniu Użytkownika może spowodować nieprawidłowe działanie niektórych funkcji Serwisu.</p><br><p>2. Administrator nie ponosi żadnej odpowiedzialności za nieprawidłowo działające funkcje Serwisu w przypadku, gdy Użytkownik ograniczy w jakikolwiek sposób możliwość zapisywania i odczytu plików Cookie.</p></div><div><h2><span>§ 8 ZMIANY W POLITYCE COOKIE</span></h2><p>1. Administrator zastrzega sobie prawo do dowolnej zmiany niniejszej Polityki Cookie bez konieczności informowania o tym użytkowników.</p><br><p>2. Wprowadzone zmiany w Polityce Cookie zawsze będą publikowane na tej stronie.</p> <br><p>3. Wprowadzone zmiany wchodzą w życie w dniu publikacji Polityki Cookie.</p> </div>',
      },
    },
    contact: {
      headline: 'Feel free to contact us!',
      email,
      address,
      phone,
      hours: 'Mon-Fri: 9am-5pm',
      companyInfo: {
        NIP,
        REGON,
        KRS,
      },
    },
  },
}
export default enContent
